import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { AppConfig } from 'src/assets/config/config/app-config';

@Component({
  selector: 'app-workflow-integrations',
  templateUrl: './workflow-integrations.component.html',
  styleUrls: ['./workflow-integrations.component.scss']
})
export class WorkflowIntegrationsComponent implements OnInit {
  isRules: boolean = false;
  isExternalConn: boolean = false;
  aclGroup: any =  this.config.getACLGroup().settings.integration;

  constructor(private config: AppConfig) { }

  ngOnInit(): void {
    this.rules()
  }

  rules() {
    this.isRules = true;
    this.isExternalConn = false;
  }

  externalConnection() {
    this.isExternalConn = true;
    this.isRules = false;
  }

}